<template>
	<div>
		<div class="contieneTexto" v-for="(texto, index) in version.textos" :key="index">
			<div class="tipo">
				<div class="row">
					<div class="col">
						<div class="form-inline">
							<div class="btn-group">
								<button class="btn btn-sm" :class="(texto.tipo === 'loca') ? 'btn-info' : 'btn-default'" @click="setTipo(texto, 'loca')">
									<i class="fa fa-venus" aria-hidden="true"></i>
								</button>
								<button class="btn btn-sm" :class="(texto.tipo === 'loc') ? 'btn-info' : 'btn-default'" @click="setTipo(texto, 'loc')">
									<i class="fa fa-mars" aria-hidden="true"></i>
								</button>
								<button class="btn btn-sm" :class="(texto.tipo === 'locx') ? 'btn-info' : 'btn-default'" @click="setTipo(texto, 'locx')">
									<i class="fa fa-transgender" aria-hidden="true"></i>
								</button>
								<button class="btn btn-sm" :class="(texto.tipo === 'tec') ? 'btn-info' : 'btn-default'" @click="setTipo(texto, 'tec')">
									<i class="fa fa-pencil-square" aria-hidden="true"></i>
								</button>
							</div>
							<div class="input-group input-group-sm" style="margin-left:10px;" v-if="texto.tipo !== 'tec'">
								<div class="input-group-prepend">
									<span class="input-group-text">
										<span v-if="texto.tipo === 'loc'">LOC</span>
										<span v-if="texto.tipo === 'loca'">LOCA</span>
										<span v-if="texto.tipo === 'locx'">LOCX</span>
									</span>
								</div>
								<input type="text" class="form-control form-control-sm" style="width:50px;" v-model.number="version.textos[index].numero" @blur="guardaTexto(index)">
							</div>
						</div>
					</div>
					<div class="col text-right">
						<button class="btn btn-sm btn-warning" style="padding-top: 2px;padding-bottom:2px;font-size:0.9em;" @click="nuevoTexto('loc', parseInt(texto.posicion))">
							<span class="fa fa-plus"></span>
						</button>
					</div>
				</div>
			</div>
			<div class="texto">
				<textarea ref="texto" v-on:focus="enfocado(texto, index)" v-model="texto.texto" placeholder="Escribe aquí el texto" class="form-control form-control-sm" autosize="true" @keyup="ajustaCaja" id="cajaTexto" @blur="guardaTexto(index)"></textarea>
			</div>
			<div class="pie">
				<div class="row">
					<div class="col text-left">
						<button class="btn btn-sm btn-danger" style="padding-top: 2px;padding-bottom:2px;font-size:0.9em;" @click="quitarTexto(texto.ID_texto)" v-if="permisoBorrar(index)">
							<span class="fa fa-trash"></span>
						</button>
					</div>
					<div class="col">
						<button class="btn btn-sm btn-warning" style="padding-top: 2px;padding-bottom:2px;font-size:0.9em;" @click="nuevoTexto('loc', parseInt(texto.posicion) + 1)">
							<span class="fa fa-plus"></span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import API from '../../services/api'

export default {
	name: 'editor-texto',
	props: ['version', 'focoactivo'],

	data: function () {
		return {
			ID_version: null,
			locutorActual: null,
			atajos: {
				ctrl: false
			},
			foco: {
				tipo: null,
				posicion: null,
				index: null
			}
		}
	},

	created () {
		if (this.version) {
			if (this.version.textos.length === 0) {
				this.nuevoTexto('loc', 1)
			}
		}

		window.addEventListener('keydown', this.teclaPulsada)
		window.addEventListener('keyup', this.teclaLiberada)
	},

	beforeDestroy () {
		window.removeEventListener('keydown', this.teclaPulsada)
		window.removeEventListener('keyup', this.teclaLiberada)
	},

	mounted () {
		this.calculaAlturas()
	},

	updated () {
		this.calculaAlturas()
		this.actualiza()
	},

	computed: {
		listaLocutores () {
			const textos = this.version.textos

			const locs = []
			for (let i = 0; i < textos.length; i++) {
				if (textos[i].tipo !== 'tec') {
					const l = textos[i].tipo + textos[i].numero

					if (locs.indexOf(l) < 0) {
						locs.push(l)
					}
				}
			}

			return locs.sort()
		}
	},

	methods: {
		enfocado (obj, index) {
			this.foco.tipo = obj.tipo
			this.foco.posicion = obj.posicion
			this.foco.index = index
		},
		teclaPulsada (e) {
			if (!this.focoactivo) {
				return
			}
			if (e.keyCode === 17) {
				this.atajos.ctrl = true
			} else {
				if (this.atajos.ctrl) {
					switch (e.keyCode) {
					case 38:
						if (this.foco.tipo !== null) {
							this.guardaTexto(this.foco.index)
							this.nuevoTexto(this.foco.tipo, this.foco.posicion, 0)
						}
						break
					case 40:
						if (this.foco.tipo !== null) {
							this.guardaTexto(this.foco.index)
							this.nuevoTexto(this.foco.tipo, this.foco.posicion + 1, 1)
						}
						break
					}
				}
			}
		},

		teclaLiberada (e) {
			if (!this.focoactivo) {
				return
			}
			if (e.keyCode === 17) {
				this.atajos.ctrl = false
			}
		},

		validaNumero (i) {
			const num = parseInt(this.version.textos[i].numero)
			this.version.textos[i].numero = (num <= 0) ? 1 : num
		},
		calculaAlturas () {
			const txt = this.$el.querySelectorAll('textarea')

			if (txt) {
				txt.forEach((el) => {
					el.style.cssText = 'height:auto; padding:0'
					// for box-sizing other than 'content-box' use:
					// el.style.cssText = '-moz-box-sizing:content-box'
					el.style.cssText = 'height:' + (el.scrollHeight + 10) + 'px'
				})
			}
		},
		setTipo (texto, tipo) {
			const datos = {
				ID_texto: texto.ID_texto,
				ID_tarea: this.version.tarea_ID,
				ID_version: this.version.ID_version,
				tipo: tipo,
				texto: texto.texto,
				posicion: texto.posicion,
				numero: texto.numero
			}

			API.setTexto(datos)
				.then(res => {
					this.actualiza(res.data.version)
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		permisoBorrar (i) {
			if (i === 0 && this.version.textos.length === 1) {
				return false
			}

			return true
		},
		nuevoTexto (tipo, posicion, idx) {
			const datos = {
				ID_tarea: this.version.tarea_ID,
				ID_version: this.version.ID_version,
				tipo: tipo,
				posicion: posicion,
				numero: 1
			}
			// creamos el texto en el backend
			API.setTexto(datos)
				.then(res => {
					this.actualiza(res.data.version)
					if (idx === 0) {
						window.setTimeout(() => {
							this.$refs.texto[this.foco.index].focus()
						}, 200)
					} else if (idx === 1) {
						window.setTimeout(() => {
							this.$refs.texto[this.foco.index + 1].focus()
						}, 200)
					}
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: (e.response) ? e.response.data.error : 'Error'
					})
				})
		},

		guardaTexto (i) {
			const texto = this.version.textos[i]
			// Guardamos los datos del texto en el servidor
			const datos = {
				ID_texto: texto.ID_texto,
				ID_tarea: this.version.tarea_ID,
				ID_version: this.version.ID_version,
				tipo: texto.tipo,
				texto: texto.texto,
				posicion: texto.posicion,
				numero: texto.numero
			}

			API.setTexto(datos)
				.then(res => {
					this.actualiza(res.data.version)
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		quitarTexto (idTexto) {
			const datos = {
				ID_texto: idTexto,
				ID_version: this.version.ID_version
			}

			API.delTexto(datos)
				.then(res => {
					this.actualiza(res.data.version)
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		ajustaCaja (ev) {
			var el = ev.srcElement

			if (!el) {
				return
			}
			setTimeout(function () {
				el.style.cssText = 'height:auto; padding:0'
				el.style.overflow = 'hidden'
				el.style.resize = 'none'
				// for box-sizing other than 'content-box' use:
				// el.style.cssText = '-moz-box-sizing:content-box'
				el.style.cssText = 'height:' + (el.scrollHeight + 10) + 'px'
			}, 0)
		},
		actualiza (version) {
			if (version) {
				this.$emit('update:version', version)
			}
		}
	}
}
</script>

<style scoped>
	.contieneTexto {
		position: relative;
		display: grid;
		width: 100%;
		margin-top: 10px;

		border: 1px solid #e0e0e0;
		border-radius: 3px;
		grid-template-columns: 1fr;
		grid-template-rows: "auto 30px";
		grid-template-areas: "tipo"
							"texto"
							"pie";
	}

	.contieneTexto > .tipo {
		grid-area: tipo;
		background-color: #F8F9FA;
		padding: 5px;
		text-align:center;
	}

	.contieneTexto > .texto {
		grid-area: texto;
	}

	.contieneTexto > .texto > textarea{
		border: none;
		resize: none;
		overflow: hidden;
	}

	.contieneTexto > .pie {
		grid-area: pie;
		background-color: #F8F9FA;
		text-align: right;
		padding: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/editor-texto.vue